<template>
  <confirm-modal ref="modal" title="Удалить табель" confirm="Удалить" reset="Отменить" mode="danger" @confirm="confirm">
    <span>
      <span v-if="timesheet">
        Табель <b>{{ timesheet.filial }}, {{ timesheet.period.toLowerCase() }}</b> будет удалён без возможности
        восстановления
      </span>
    </span>
  </confirm-modal>
</template>

<script>
import ConfirmModal from "@/components/modals/confirm-modal";

export default {
  components: { ConfirmModal },
  data() {
    return {
      id: null,
      timesheet: null,
      pending: false,
    };
  },
  methods: {
    open(timesheet) {
      this.id = timesheet.id;
      this.timesheet = timesheet;
      this.$refs.modal.open();
    },
    close() {
      this.$refs.modal.close();
      this.id = null;
      this.timesheet = null;
      this.pending = false;
    },
    confirm() {
      this.pending = true;
      this.$store.dispatch("timesheets/removeTimesheet", { id: this.id }).then(() => {
        this.close();
        this.$nextTick(() => {
          this.$emit("remove", this.id);
        });
      });
    },
  },
};
</script>
